import { useLegalComercio } from "../../context/LegalComercioContext";

interface AceptacionCondicionesPagoProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  id?: string;
  className?: string;
}

export function AceptacionCondicionesPago({
  checked,
  onChange,
  id = "acepta-condiciones-pago",
  className = "",
}: AceptacionCondicionesPagoProps) {
  const { openLegalModal } = useLegalComercio();

  return (
    <div
      className={`rounded-lg border border-gray-200 bg-gray-50/80 p-3 text-sm text-[#2C2C2C] ${className}`}
    >
      <label htmlFor={id} className="flex cursor-pointer items-start gap-3">
        <input
          id={id}
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          className="mt-0.5 h-4 w-4 shrink-0 rounded border-gray-300 text-[#1A3AB8] focus:ring-[#1A3AB8]"
          required
        />
        <span>
          Acepto las{" "}
          <button
            type="button"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              openLegalModal();
            }}
            className="font-medium text-[#1A3AB8] underline underline-offset-2 hover:text-[#15308a]"
          >
            condiciones de compra e información legal
          </button>{" "}
          (obligatorio para continuar).
        </span>
      </label>
    </div>
  );
}
